import { render, staticRenderFns } from "./PickMe.vue?vue&type=template&id=2777c222&scoped=true&"
import script from "./PickMe.vue?vue&type=script&lang=js&"
export * from "./PickMe.vue?vue&type=script&lang=js&"
import style0 from "./PickMe.vue?vue&type=style&index=0&id=2777c222&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2777c222",
  null
  
)

export default component.exports